var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVisaSmall = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 16,
  fill: "none",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 21,
  height: 16,
  fill: "#172B85",
  rx: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M6.858 10.337H5.62L4.69 6.633c-.044-.17-.137-.321-.275-.392a3.9 3.9 0 0 0-1.135-.392v-.143h1.995c.275 0 .481.214.516.463l.482 2.672L7.51 5.706h1.204zm2.545 0h-1.17l.964-4.631h1.169zm2.476-3.348c.034-.25.24-.392.481-.392.379-.036.791.036 1.135.213l.207-.997a2.9 2.9 0 0 0-1.066-.214c-1.135 0-1.961.642-1.961 1.532 0 .677.585 1.033.998 1.247.447.213.619.356.584.57 0 .32-.344.463-.687.463-.413 0-.826-.107-1.204-.286l-.207.998c.413.178.86.25 1.273.25 1.272.035 2.063-.606 2.063-1.568 0-1.211-1.616-1.282-1.616-1.816m5.708 3.348-.928-4.631h-.997a.52.52 0 0 0-.482.356l-1.72 4.275h1.205l.24-.677h1.479l.137.677zm-1.753-3.384.343 1.746h-.962z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVisaSmall);
export default ForwardRef;